module.exports = __webpack_public_path__ + "static/media/cambridge2.503c7759.png";